module.exports = __webpack_public_path__ + "img/tpaga.f32efd9.png";